// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"J1-z","colorTextValue":"K1-z","swatches":"L1-z","collapseLink":"M1-z","isCollapsed":"N1-z","dropdown":"O1-z","disabled":"P1-z"};